import Badge01 from './01.png';
import Badge02 from './02.png';
import Badge03 from './03.png';
import Badge04 from './04.png';
import Badge05 from './05.png';
import Badge06 from './06.png';
import Badge07 from './07.png';
import Badge08 from './08.png';
import Badge09 from './09.png';
import Badge10 from './10.png';
import Badge11 from './11.png';
import Badge12 from './12.png';

export { Badge01, Badge02, Badge03, Badge04, Badge05, Badge06, Badge07, Badge08, Badge09, Badge10, Badge11, Badge12 };
